export default {
  order: 9,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'TROPICAL_TREE_COVER',
    order: 9,
    type: 'remoteDataLayer',
    uuid: 'b9183eca-84ed-48ed-83d5-a146a6e2a079',
    groupId: 'GROUP_LC',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Tropical tree cover',
          fr: 'Couvert végétal tropica',
          es: 'Cobertura arbórea tropical',
          pt: 'Cobertura de árvores tropicais',
          id: 'Tropical tree cover',
          zh: 'Tropical tree cover',
          ka: 'Tropical tree cover',
        },
        type: 'basic',
        items: [
          {
            outlineColor: '#555555',
            color: '#2DBC27',
            name: {
              en: 'Tropical tree cover',
              fr: 'Couvert végétal tropica',
              es: 'Cobertura arbórea tropical',
              pt: 'Cobertura de árvores tropicais',
              id: 'Tropical tree cover',
              zh: 'Tropical tree cover',
              ka: 'Tropical tree cover',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'TROPICAL_TREE_COVER',
    type: 'tropical-tree-cover',
    url: 'https://tiles.globalforestwatch.org/wri_trees_in_mosaic_landscapes/v20220922/tcd_40/{z}/{x}/{y}.png',
    technicalName: 'wri_tropical_tree_cover',
    colormap: [[1, 0, 179, 0]],
    inputRange: [30, 101],
    outputRange: [1],
    opacity: 0.8,
    label: {
      en: 'Tropical tree cover',
      fr: 'Couvert végétal tropica',
      es: 'Cobertura arbórea tropical',
      pt: 'Cobertura de árvores tropicais',
      id: 'Tropical tree cover',
      zh: 'Tropical tree cover',
      ka: 'Tropical tree cover',
    },
    sublabel: {
      en: '2020, 10m/0.5ha, tropical, UMD',
      fr: '2020, 10m/0.5ha, tropical, WRI',
      es: '2020, 10m/0.5ha, tropical, WRI',
      pt: '2020, 10m/0.5ha, tropical, WRI',
      id: '2020, 10m/0.5ha, tropical, WRI',
      zh: '2020年，10米/0.5公顷，热带，世界资源研究所',
      ka: '2020, 10m/0.5ha, tropical, WRI',
    },
  },
  isMetadataError: false,
  isError: false,
};
